import anime from "animejs";

export default function (container, widthCollapsed = 70, toggler = null) {
  if (!toggler && container) {
    toggler = [container.querySelector(".navbar__toggler")];
  }

  const toggle = function () {
    let targetWidth = widthCollapsed;

    if (!container.classList.contains("is-opened")) {
      targetWidth = container.scrollWidth;
    }

    container.classList.toggle("is-opened");
    anime({
      targets: container,
      width: (targetWidth + 5) + "px",
      easing: "linear",
      duration: 200,
    });
  };
  if (toggler) {
    for (let t of toggler) {
      t.addEventListener("click", toggle);
    }
  }
}
